import { useState } from "react";

export const usePromptOnChange = <T>(
  shouldPrompt: boolean,
  onChange: (value: T) => void
) => {

  const [displayPrompt, setDisplayPrompt] = useState(false);
  const [continueWithValue, setContinueWithValue] = useState<T>();

  const onPromptedChange = (value: T) => {
    if (shouldPrompt) {
      setDisplayPrompt(true);
      setContinueWithValue(value);
    } else {
      onChange(value);
    }
  };

  const onContinue = () => {
    onChange(continueWithValue);
  };

  const onHide = () => {
    setDisplayPrompt(false);
  };

  return { displayPrompt, onPromptedChange, onContinue, onHide };
};
